import { SidePanelViewModel } from "../viewmodels/SidePanelViewModel.js";
import { AppNav } from "./AppNav/index.js";
import { SidePanel } from "./SidePanel/SidePanel.js";
import { AccessGuard } from "./AccessGuard.js";
import "react";
import { jsx, jsxs } from "react/jsx-runtime";
import classnames from "classnames";
import { useSingleton } from "mvc-kit/react";
//#region src/modules/AppWrapper2/components/AppShell.tsx
function AppShell({ children }) {
	const panelVM = useSingleton(SidePanelViewModel);
	return /* @__PURE__ */ jsxs("div", {
		className: "app-wrapper-container",
		children: [/* @__PURE__ */ jsx("div", {
			className: "app-wrapper-nav-container",
			children: /* @__PURE__ */ jsx(AppNav, {})
		}), /* @__PURE__ */ jsxs("div", {
			className: "app-wrapper-main-container",
			children: [/* @__PURE__ */ jsx(AccessGuard, { children: /* @__PURE__ */ jsx("div", {
				className: classnames("app-wrapper-app-container", { "fixed-side-panel-sibling": panelVM.state.isOpen && panelVM.state.isPinned }),
				children
			}) }), /* @__PURE__ */ jsx(SidePanel, {})]
		})]
	});
}
//#endregion
export { AppShell };

//# sourceMappingURL=AppShell.js.map